import React from 'react'
import { Alert, } from 'reactstrap'
import { Link, } from 'react-router-dom'
import timestamper from '../../helpers/timestamper'

/*
  <ResetsMessageBar
    isFetchingReset={this.props.isFetchingReset}
    isFetchingResetError={this.props.isFetchingResetError}
    isSavingError={this.props.isSavingError}
    reset={this.props.reset}
  />
*/

export default function ResetsMessageBar ({isFetchingReset, isFetchingResetError, isSavingError, reset, isStudent}) {
  let component = null
  
  if (isFetchingResetError) {
    let errorMessage = (
      `Error loading reset code. Check the link in your email, 
      and if this issue persists, please ask your administrator 
      to reset again or contact customer support.`
    )
    if (isFetchingResetError === 'Reset code not found.') {
      errorMessage = (
        `Reset code not found. Check the link in your email, and 
        if this issue persists, please request a new password reset 
        or contact customer support.`
      )
    }
    component = <Alert color='danger'>{errorMessage}</Alert>
  } else if (isSavingError) {
    const errorMessage = (
      `Error saving your new password. Please check your internet
      connection and try again. If this issue persists, please 
      contact customer support.`
    )
    component = <Alert color='danger'>{errorMessage}</Alert>
  }

  const time = timestamper()

  if (reset) {
    if (reset.expirationDate < time) {
      const errorMessage = (
        `This reset code has expired. For security reasons, reset codes
        expire after one hour. Please request a new password reset, 
        or contact customer support.`
      )
      component = <Alert color='danger'>{errorMessage}</Alert>
    }
    if (reset.complete) {
      let query = ''
      if (!isStudent) {
        query = `?gua=${reset.userId}`
      }
      component = (
        <Alert color='warning'>
          You have already reset your password using this reset request. Click here to
          &nbsp;<Link to={`/login`}>log in</Link>. If you have forgotten your password or have not created one,
          click "Forgot password?" at the log-in menu.
        </Alert>
      )
    }
  }




  
  return (
    component
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/ResetsMessageBar.js